import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityFeed = ({ activities, title = "Actividad Reciente", emptyMessage = "No hay actividad reciente" }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'vin_lookup':
        return 'Search';
      case 'user_login':
        return 'LogIn';
      case 'user_logout':
        return 'LogOut';
      case 'user_created':
        return 'UserPlus';
      case 'system_alert':
        return 'AlertTriangle';
      case 'export':
        return 'Download';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'vin_lookup':
        return 'text-primary';
      case 'user_login':
        return 'text-success';
      case 'user_logout':
        return 'text-muted-foreground';
      case 'user_created':
        return 'text-primary';
      case 'system_alert':
        return 'text-warning';
      case 'export':
        return 'text-secondary';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Ahora mismo';
    if (diffInMinutes < 60) return `Hace ${diffInMinutes} min`;
    if (diffInMinutes < 1440) return `Hace ${Math.floor(diffInMinutes / 60)} h`;
    return date?.toLocaleDateString('es-MX', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          <Icon name="RefreshCw" size={16} className="text-muted-foreground cursor-pointer hover:text-foreground transition-smooth" />
        </div>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {!activities || activities?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Activity" size={48} className="text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">{emptyMessage}</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {activities?.map((activity) => (
              <div key={activity?.id} className="p-4 hover:bg-muted/50 transition-smooth">
                <div className="flex items-start space-x-3">
                  <div className={`flex items-center justify-center w-8 h-8 rounded-full bg-muted ${getActivityColor(activity?.type)}`}>
                    <Icon name={getActivityIcon(activity?.type)} size={16} />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2 mb-1">
                      {activity?.user?.avatar && (
                        <Image
                          src={activity?.user?.avatar}
                          alt={activity?.user?.avatarAlt}
                          className="w-5 h-5 rounded-full"
                        />
                      )}
                      <p className="text-sm font-medium text-foreground truncate">
                        {activity?.user?.name || 'Sistema'}
                      </p>
                      <span className="text-xs text-muted-foreground">
                        {formatTimestamp(activity?.timestamp)}
                      </span>
                    </div>
                    
                    <p className="text-sm text-muted-foreground mb-1">
                      {activity?.description}
                    </p>
                    
                    {activity?.details && (
                      <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                        {activity?.details?.vin && (
                          <span className="font-mono">VIN: {activity?.details?.vin}</span>
                        )}
                        {activity?.details?.ip && (
                          <span>IP: {activity?.details?.ip}</span>
                        )}
                        {activity?.details?.location && (
                          <span>📍 {activity?.details?.location}</span>
                        )}
                      </div>
                    )}
                  </div>
                  
                  {activity?.status && (
                    <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                      activity?.status === 'success' ?'bg-success/10 text-success' 
                        : activity?.status === 'error' ?'bg-error/10 text-error' :'bg-warning/10 text-warning'
                    }`}>
                      {activity?.status === 'success' ? 'Éxito' : 
                       activity?.status === 'error' ? 'Error' : 'Pendiente'}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;